import React, { useState } from 'react';
import { X, AlertCircle, CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
interface SkipWorkoutModalProps {
  onClose: () => void;
}
export function SkipWorkoutModal({
  onClose
}: SkipWorkoutModalProps) {
  const [isSuccess, setIsSuccess] = useState(false);
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-365">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] p-6 shadow-2xl animate-in zoom-in-95 duration-200 relative overflow-hidden" data-id="element-366">
        {!isSuccess && <button onClick={onClose} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-367">
            <X size={20} data-id="element-368" />
          </button>}

        {!isSuccess ? <div className="animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-369">
            <div className="w-12 h-12 bg-pink-50 text-pink-500 rounded-full flex items-center justify-center mb-5 mx-auto" data-id="element-370">
              <AlertCircle size={28} data-id="element-371" />
            </div>

            <div className="text-center mb-8" data-id="element-372">
              <h2 className="text-2xl font-extrabold text-slate-800 mb-2" data-id="element-373">
                Skip this workout?
              </h2>
              <p className="text-slate-500 font-medium text-sm leading-relaxed" data-id="element-374">
                This workout will be marked as skipped. It won't appear in your
                completed training history or exercise progress.
              </p>
            </div>

            <div className="space-y-3" data-id="element-375">
              <Button variant="secondary" fullWidth onClick={() => setIsSuccess(true)} data-id="element-376">
                Skip workout
              </Button>
              <Button variant="outline" fullWidth onClick={onClose} data-id="element-377">
                Keep it for now
              </Button>
            </div>
          </div> : <div className="animate-in fade-in slide-in-from-right-4 duration-300 py-2" data-id="element-378">
            <div className="w-12 h-12 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center mb-5 mx-auto" data-id="element-379">
              <CheckCircle2 size={28} data-id="element-380" />
            </div>

            <div className="text-center mb-8" data-id="element-381">
              <h2 className="text-2xl font-extrabold text-slate-800 mb-2" data-id="element-382">
                Workout skipped
              </h2>
              <p className="text-slate-500 font-medium text-sm leading-relaxed" data-id="element-383">
                This session has been removed from your active reminders.
              </p>
            </div>

            <Button variant="primary" fullWidth onClick={onClose} data-id="element-384">
              Done
            </Button>
          </div>}
      </div>
    </div>;
}